import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces, Trans } from 'react-i18next';
import { loadIndividualConsultationDocuments } from './actions';
import List from './TeacherDocumentsList';
import { Nav, NavItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const DocumentType = 'IndividualConsultationIndividualProgram';

class TeacherDocuments extends Component {
    constructor(props) {
        super(props);
        this.handleListEvent = this.handleListEvent.bind(this);
        this.handleChildSelect = this.handleChildSelect.bind(this);

        const firstChild = this.props.children && this.props.children[0];
        this.state = {
            selectedChildId: firstChild && firstChild.id
        };
    }

    componentDidMount() {
        if (this.state.selectedChildId) {
            this.handleChildSelect(this.state.selectedChildId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((!this.props.children || this.props.children.length == 0) && nextProps.children && nextProps.children.length > 0) {
            this.handleChildSelect(nextProps.children[0].id);
        }
    }

    handleChildSelect(childId) {
        this.setState({ selectedChildId: childId });

        const pagination = this.props.paginationByChildAndType[`${childId}-${DocumentType}`] || { ids: [], pageNumber: 1, pageSize: 10 };
        this.loadListData(childId, pagination);
    }

    loadListData(childId, { sortKey = 'created', sortDirection = 'desc', pageNumber, pageSize }) {
        if (childId) {
            this.props.loadIndividualConsultationDocuments({
                childId,
                teacherDocumentsOnly: true,
                type: DocumentType,
                sortKey, sortDirection, pageSize, pageNumber
            });
        }
    }

    handleListEvent(listPagination) {
        this.loadListData(this.state.selectedChildId, listPagination);
    }

    render() {
        const { children, paginationByChildAndType, individualConsultationDocuments, hasChildren, t } = this.props;

        if (!children || children.length == 0) {
            return <Trans i18nKey='FO_IndividualConsultationDocument_NoConsultations'>
                <Link to={`/individual-consultation/booking/child?add=${!hasChildren}&reset=true`}>Book</Link> individual consultation
            </Trans>;
        }

        const { selectedChildId } = this.state;

        const pagination = selectedChildId && paginationByChildAndType[`${selectedChildId}-${DocumentType}`] || { ids: [], pageNumber: 1, pageSize: 10 };
        const data = pagination.ids.map(id => individualConsultationDocuments[id])

        return <div>
            {children.length > 1 ? <Nav id='children' bsStyle='pills' activeKey={selectedChildId} onSelect={this.handleChildSelect}>
                {children.map(x => <NavItem key={x.id} eventKey={x.id} title={x.fullName}>
                    {x.fullName}
                </NavItem>)}
            </Nav> : <h3>{children[0].fullName}</h3>}
            <List data={data} onFetchData={this.handleListEvent} {...pagination} />
        </div>;
    }
}

const mapStateToProps = state => {
    const { parent: { children }, entities: { individualConsultationDocuments }, pagination } = state;

    const paginationByChildAndType = pagination.individualConsultationDocumentsByChildAndType;

    return {
        paginationByChildAndType,
        individualConsultationDocuments,
        children: children.filter(x => x.hasIndividualConsultation),
        hasChildren: children.length > 0
    };
};

export default connect(mapStateToProps, {
    loadIndividualConsultationDocuments
})(withNamespaces()(TeacherDocuments));